import { cn } from "@utils/tw"
import {
  NewsItemFragment,
  NewsItemHeaderSingleFragment,
  NewsItemMinimalFragment,
  ResponsiveImageFragment,
} from "../../types.graphql"
import { Link } from "eddev/routing"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button } from "@components/ui/Button"
import dayjs from "dayjs"
import { Chip } from "@components/atoms/Chip"

export const NewsTile = ({
  item,
  indexLayout = false,
  hideExcerpt = false,
  useImageRatio = false,
}: {
  item: NewsItemMinimalFragment & NewsItemHeaderSingleFragment
  indexLayout?: boolean
  hideExcerpt?: boolean
  useImageRatio?: boolean
}) => {
  const image = item.newsHeader?.featuredImage
  return (
    <div className={cn("flex flex-col gap-4", indexLayout && "md:flex-row-reverse md:p-4 md:bg-grey8 md:gap-8")}>
      {image && (
        <Link href={item.uri} className={cn("relative group", indexLayout && "md:w-[56%] md:shrink-0")}>
          <ResponsiveImage {...image} aspect={useImageRatio ? 16 / 9 : indexLayout ? 1.8 / 1 : undefined} />

          <div className="group-hover:opacity-100 opacity-0 transition-opacity absolute left-2 bottom-2 pointer-events-none">
            <Chip variant="light">Read More</Chip>
          </div>
        </Link>
      )}
      <div className={cn("w-full flex flex-col gap-5", indexLayout && "px-2 py-4")}>
        {indexLayout && <p className="type-label-m">{dayjs(item.date).format("MMMM DD, YYYY")}</p>}
        <Link href={item.uri}>
          <p className={cn(indexLayout ? "type-title-xl" : "type-title-xs")}>{item.title}</p>
        </Link>
        {!indexLayout && (
          <div className={cn("flex gap-2 flex-wrap")}>
            <Button size="sm" variant="secondary" className="pointer-events-none">
              {dayjs(item.date).format("MMMM DD, YYYY")}
            </Button>
            {item.newsHeader?.category && (
              <Button href={`/news/?category=${item.newsHeader.category.slug}`} size="sm" variant="secondary">
                {item.newsHeader?.category.name}
              </Button>
            )}
            {item.newsHeader?.tags?.map((tag, i) => (
              <Button key={i} href={`/news/?tag[]=${tag?.slug}`} size="sm" variant="secondary">
                {tag?.name}
              </Button>
            ))}
          </div>
        )}
        {!hideExcerpt && (
          <p
            className={cn("type-body-m", indexLayout && "md:mt-6")}
            dangerouslySetInnerHTML={{ __html: item.excerpt?.replaceAll("[&hellip;]", "...") || "" }}
          />
        )}
      </div>
    </div>
  )
}
